

import React, { useEffect, useRef, useState } from 'react';

import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { Button, Grid } from '@mui/material'

import filterIcon from './../../../../assets/icons/filter 1.png'
import searchIcon from './../../../../assets/icons/searchIcon 1.png'
import AddItemDialogComponent from './AddItemDialog.tsx'

import FilterComponents from '../FilterComponents.tsx';
import SectionTable from '../SectionTable.tsx';
import AddSectionDialog from '../AddSectionDialog.tsx';
import burger from './../../../../assets/icons/burger.png'
import edit from './../../../../assets/icons/edit.png'
import bin from './../../../../assets/icons/recycle-binColor.png'
import ediPencil from './../../../../assets/icons/editPencil.png'
//table
import arrowUp from './../../../../assets/icons/arrowup.png'
import arrowDown from './../../../../assets/icons/arrowDown.png'
import Paper from '@mui/material/Paper';

import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import SectionItemsDialog from '../SectionItemsDialog/SectionItemsDialog.tsx';
//table end
import './AddSubSection.css'
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import editImg from './../../../../assets/icons/edit.png'
import axios from 'axios';


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditSection from '../EditSection/EditSection.tsx';
import LoadingView from '../../../components/LoadingView/LoadingView';
import LeftArrow from "../../../../assets/icons/left-arrow.png";
import RightArrow from "../../../../assets/icons/right-arrow.png";
import { Swiper, SwiperSlide } from "swiper/react";
import AddSubFilterDialog from '../AddSubFilter/AddSubFilterDialog.tsx';
import EditSubFilter from './EditSubFilter.tsx';
import RichTextEditor from '../../../components/RichTextEditor.tsx';
import { X } from 'lucide-react';


//table start
interface Column {
  id: 'checkBox' | 'sectionid' | 'sectionname' | 'foodname';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'checkBox', label: 'Check', minWidth: 100 },
  { id: 'sectionid', label: 'Id', minWidth: 100 },
  { id: 'sectionname', label: 'Name', minWidth: 100 },

  {
    id: 'foodname',
    label: 'Icon',
    minWidth: 100,
    align: 'left',

  },


];



function createData(
  sectionid: string,
  sectionname: string,



) {

  return { sectionid, sectionname };
}

const rows = [
  createData('B10101', 'Standard', false),
  createData('B10101', 'Special', false),
  createData('B10101', 'Shop', false),
  createData('B10101', 'Set menu', false)
];


//table end

function AddSubSection(props) {

  const [selectedData, setSelectedData] = useState({})
  const sliderRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  
  const [openAddSection, setOpenAddSection] = useState(false);
  const [openSection, setopenSection] = useState(false);
  const [openEditSection, setOpenEditSection] = useState(false);
  const [dialogType, setDialogType] = useState('');

  const handleAddSectionDialogData = (data) => {

    setSelectedData(data);
    setLoading(true);
    setDataRows([]);
    setSectionDialogOpen(false)
    loadMenuData();
    loadData(selectedMenu)
  }

  const handleClickOpen = () => {
    setOpenAddSection(true);
    setDialogType('add');
  }

  const handleAddItem = (AddSectionData) => {
    loadData(selectedMenu)
    setOpenAddSection(AddSectionData)
    //loadData(selectedMenu)

  }

  const handleSectionOpen = (AddSectionData) => {
    setopenSection(false)
    //loadData(selectedMenu)

  }
  const handleEditItem = (AddSectionData) => {
    setOpenEditSection(AddSectionData);
    loadData(selectedMenu);
  }
  //table start

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //table end
  const [value, setValue] = React.useState('1')

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  const [sectionItemsToggle, setsectionItemsToggle] = React.useState(false);
  const [sectionItemsdialogType, setsectionItemsdialogType] = React.useState("");
  const onHandlesectionItems = () => {
    setsectionItemsToggle(false);
  }
  const rows = [
    createData('B10101', 'Standard', false),
    createData('B10102', 'Special', false),
    createData('B10103', 'Shop', false),
    createData('B10104', 'Set menu', false)
  ];


 const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [selectedSections, setSelectedSections] = React.useState([]);
  const [tempselectedSections, settempSelectedSections] = React.useState([]);
  const [countSelectedDatas, setcountSelectedDatas] = React.useState(0);
    const [searchQuery, setSearchQuery] = useState("");
  React.useEffect(() => {
    setSelectedSections(tempselectedSections);

  }, [selectedSections])
  const handleCheckChange = (props) => {
    console.log("props: " + props.sectionid);
    var temp = selectedSections;
    var count = selectedSections.length;
    var val = selectedSections.find(x => x.sectionid == props.sectionid);
    console.log("val: " + val);
    if (val != undefined) {
      var index = selectedSections.indexOf(val);
      console.log("temp.indexOf(val): " + index);
      temp = selectedSections.slice(index, 1);
      count -= 1;
    }
    else {
      temp.push(props);
      count += 1;
    }
    settempSelectedSections(temp);
    console.log("temp: " + temp);
    setSelectedSections([]);
    console.log("selectedSections: " + selectedSections);
    setcountSelectedDatas(count)
  }

   const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));
const [subFilters, setSubFilters] = useState([]);

const loadSubFilters = async () => {
  try {
    setLoading(true);

    const response = await axios.get(
      apiAddress + "/api/SubSection/SubfiltersByRestaurant/" +
      Restauranttoken.id
    );

    console.log("RAW:", response.data);

    // শুধুমাত্র isActive: true data নিবে
    const activeData = response.data.filter(dt => dt.isActive === true);
    
    setSubFilters(activeData);
    setDataCollection(activeData);
    
    const list = activeData.map((dt) => ({
      id: dt.id,
      filterName: dt.subFilterName,
      icon: dt.iconUrl,
      isActive: dt.isActive,
    }));

    console.log("Filter List:", list);
    setDataRows(list);
    console.log("Processed SubFilters:", activeData);
  } catch (error) {
    console.error("Error fetching:", error);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  loadSubFilters();
}, []);






  const changeOrderByTextBox = (props, type) => {
    console.log(props.target.value);
    console.log(type);

    if (props.target.value != "") {
      setLoading(true);
      if (lastRank - 1 < props.target.value) {
        setLoading(false);
        toast.error("please select a valid number", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else {
        axios
          .put(apiAddress + "/api/SubSection/updaterankwithtextboxsection?id=" + type.id + "&newRank=" + props.target.value)
          .then((response) => {
            console.log(response.data);
            setDataRows([]);
            toast.success("Successfully updated", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            loadData(selectedMenu);
          });
      }

    }
  }
  const [sectionNameItemsdialogType, setsectionNameItemsdialogType] = React.useState("");
  const columnsdatas = [
   
     
    {
      field: 'filterName', headerName: 'Name', renderCell: (params) =>
        <div className='d-flex ' style={{ gap: "10px" }}>
          <span onClick={() => { setsectionItemsToggle(true); setsectionItemsdialogType(params.row.id); setsectionNameItemsdialogType(params.value) }} style={{ color: "blue", cursor: "pointer" }}>{params.value}</span>
          <div style={{ color: "blue", cursor: "pointer" }} onClick={() => { onEditClick(params.row.id) }}>
            <img src={ediPencil} alt="" style={{ width: "1rem" }} />
          </div>
        </div>, align: 'center', headerAlign: 'center', flex: 1
    },
    {
      field: 'icon',
      headerName: 'Icon',
      renderCell: (params) => <img src={params.value} alt='burger' style={{ width: '2rem', height: '2rem' }} />, align: 'center', headerAlign: 'center', flex: 1
    },

  ];

  const changeOrder = (props, type) => {
    console.log(props);
    console.log(type);
    setLoading(true);
    axios
      .put(apiAddress + "/api/SubSection/updateranksection?id=" + props.id + "&status=" + type)
      .then((response) => {
        console.log(response.data);
        setDataRows([]);
        toast.success("Successfully updated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        loadData(selectedMenu);
      });
  }


  const [dataRows, setDataRows] = useState([])

  React.useEffect(() => {

    loadMenuData();
    loadAllMenu();
  }, [])
  const apiAddress = process.env.REACT_APP_SECRET;
  const [dataCollection, setDataCollection] = useState([]);
  const [lastRank, setLastRank] = useState(1);
  const [Loading, setLoading] = React.useState(false);
  
const loadData = (props) => {
  setLoading(true);

  if (props !== undefined) {
    console.log(props);
    setLastRank(1);

    axios
      .get(apiAddress + "/api/SubSection/getallsubsectionbymenuid?id=" + props.id)
      .then((response) => {
        console.log(response.data);

        // const collectionList = response.data;
        // setDataCollection(collectionList);

        const list = response.data.map((dt) => ({
          id: dt.id,
          displayOrder: dt.rank,
          name: dt.keywordName,
          icon: dt.iconUrl,
          type: dt.sectionTypeId,
        }));

        console.log(list);

        if (list.length > 0) {
          setDataRows(list);
          const rank = list[list.length - 1].displayOrder;
          setLastRank(rank + 1);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to load data");
      })
      .finally(() => {
        setLoading(false);
      });
  } else {
    setLoading(false); // In case props is undefined
  }




  }
  const [selectedDataRows, setSelectedDatarows] = React.useState([]);
  const [selectedDataRowsCount, setSelectedDatarowsCount] = React.useState([]);




  const getselectedData = (props) => {
    console.log(props);
    // setSelectedDatarows(props)
    console.log(selectedDataRows[value])
    if (selectedDataRows[value] === undefined) {
      selectedDataRows[value] = [];
      selectedDataRowsCount[value] = [];
    }
    selectedDataRows[value] = props;
    selectedDataRowsCount[value] = props.length;
    setSelectedDatarowsCount(selectedDataRowsCount);
    console.log("selectedDataRows[value]: " + selectedDataRows[value]);
    setSelectedDatarows(selectedDataRows);
    setcountSelectedDatas(props.length);
  }
  console.log(selectedDataRows)
  const TabWithCount = ({ children, count }) => {
    console.log("count: " + count);
    console.log("value: " + value);
    return (
      <div >
        {
          selectedDataRowsCount[count] > 0 ?
            <div className='d-flex align-items-center' style={{ gap: "10px" }}>
              <span>{children}</span> <div className='roundedSelectionCorner'> {selectedDataRowsCount[count]} items selected</div>
            </div> : <span>{children}</span>
        }

      </div>
    );
  };
const deleteBin = () => {
  var valid = true;
  console.log(selectedDataRows);

  if (selectedDataRows[value] == undefined) {
    valid = false;
    toast.error("please select any section", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  } else {
    axios
      .put(
        apiAddress + "/api/SubSection/SoftDeleteSubFilter",
        selectedDataRows[value]
      )
      .then((response) => {
        console.log(response.data);
        toast.success("Successfully deleted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        // Clear selection
        setSelectedDatarows({});
        setSelectedDatarowsCount([]);
        setcountSelectedDatas(0);
        // Reload data
        loadSubFilters();
      })
      .catch((error) => {
        console.error("Delete Error:", error);
        toast.error("Failed to delete. Please try again.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  }
};








  const [selectedDataForEdit, setSelectedDataForEdit] = useState();

  const onEditClick = (props) => {
    console.log(props);
    var obj = dataCollection.find(x => x.id == props);
    console.log(obj);
    setSelectedDataForEdit(obj);
    setOpenEditSection(true);
  }
  const [tabViewItemList, settabViewItemList] = React.useState([]);

  const loadMenuData = () => {
    const restaurant = localStorage.getItem('restaurant');
    var res = JSON.parse(restaurant);
    console.log(res);
    axios
      .get(apiAddress + "/api/Section/getallsectionbyrestaurantid?restaurantId=" + res.id)
      .then((response) => {
        console.log(response.data);

        
        settabViewItemList(response.data)
        if (response.data.length > 0) {
          loadData(response.data[0]);
        }

      });
  }
  const [menuList, setMenuList] = useState([])
  const loadAllMenu = () => {
    axios
      .get(apiAddress + "/api/Menu/GetAllMenuIconListAsync")
      .then((response) => {
        console.log(response.data);
        if (response.data.length > 0) {
          var list = []
          response.data.map((dt, i) => {
            var obj = { id: dt.id, title: dt.menuName }
            list.push(obj)
          })
          setMenuList(list);
          // settabViewItemList(response.data)
          loadData(response.data[0]);
          // setselectedMenu(response.data[0]);
        }

      });
  }
  console.log(menuList)
  const [selectedMenu, setselectedMenu] = useState();

  const onTabClick = (data) => {
    setselectedMenu(data);
    setDataRows([]);
    loadData(data)
  }

  const TabViewItem = ({ children, count, data }) => {

    return (
      <div onClick={() => { onTabClick(data) }}>
        {
          <div>
            {children}
          </div>
        }

      </div>
    );
  }
  const [openAddMenu, setopenAddMenu] = useState(false);
  // const handleClickAddMenuOpen = () => {
  //   setopenAddMenu(true);

  // }
  const [sectionDialogOpen, setSectionDialogOpen] = useState(false)
  const handleClickSectionDialogOpen = () => {
    setSectionDialogOpen(true)
  }
  const handleSectionDialogClose = (props) => {
    setLoading(true);
    setDataRows([]);
    setSectionDialogOpen(props)
    loadMenuData();
    loadData(selectedMenu)
  }
  const handleAddMenu = (AddSectionData) => {
    setopenAddMenu(false);
    loadMenuData();
  }
   const handleClickAddMenuOpen = () => {
    setopenAddMenu(true);
    // alert("Menu")
  };
  const handleNext = (ref) => {
    if (ref.current) {
      ref.current.swiper.slideNext();
    }
  };
  const handlePrev = (ref) => {
    if (ref.current) {
      ref.current.swiper.slidePrev();
    }
  };  

  const filteredRows = dataRows.filter((item) => {
    const hay = (item.name || item.filterName || "").toString().toLowerCase();
    const needle = (searchQuery || "").toString().toLowerCase();
    return hay.includes(needle);
  });
  return (
    <div>
      <ToastContainer />
      <LoadingView open={Loading} close={() => { setLoading(false) }} />
      <AddSectionDialog open={sectionDialogOpen} onHandleAddItem={handleSectionDialogClose} onHandleSelectedData={handleAddSectionDialogData} menuList={menuList} />
      {tabViewItemList.length > 0 ? (
        <TabContext value={value}>
    


          {
            tabViewItemList.map((dt, i) => {
              return (
                // <Tab label={dt.menuName} value={i} />
                value == i ? (
                  <>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      mt={2}
                      mb={2}
                    >
                      <Grid item>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item>
                            <Button
                              color="primary"
                              size="medium"
                              variant="contained"
                              style={{ borderRadius: '50%', minWidth: 'auto' }}
                              onClick={handleClickOpen}
                            >
                              +
                            </Button>
                          </Grid>
                          <Grid item>
                            <img src={filterIcon} alt="" style={{ width: '1rem' }} />
                          </Grid>
                          <Grid item>Add Filter</Grid>

                          <Grid item>
                            <div className='roundedCorner'>
                              <img src={bin} alt="" style={{ width: '1rem' }} onClick={() => { deleteBin() }} />
                            </div>
                          </Grid>
                          <Grid item>

                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Grid container flexDirection={'column'} alignItems={'center'}>
                           <Grid item>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  border: "1px solid #ccc",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                  background: "#fff",
                                }}
                              >
                                <img
                                  src={searchIcon}
                                  alt=""
                                  style={{ width: "1rem", opacity: 0.7 }}
                                />
                          
                                      <div
  style={{
    position: "relative",
    display: "flex",
    alignItems: "center",
  }}
>
  <input
    type="text"
    placeholder="Search..."
    style={{
      border: "none",
      outline: "none",
      fontSize: "14px",
      paddingRight: "22px", 
    }}
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
  />

  {searchQuery && (
    <X
      size={16}
      style={{
        position: "absolute",
        right: "4px",
        cursor: "pointer",
        color: "#888",
      }}
      onClick={() => setSearchQuery("")}
    />
  )}
</div>
                              </div>
                            </Grid>
                          <Grid item></Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>

                      {
                        dataRows.length > 0 ? (

                          selectedDataRows[value] != undefined ? 
                          <CustomDataGrid columns={columnsdatas}
                           dataRows={filteredRows}
                           
                           getselectedData={getselectedData}
                            selectedRows={selectedDataRows[value]}
                             isLoading={Loading} /> : 
                             <CustomDataGrid columns={columnsdatas}
                               dataRows={filteredRows}
                               getselectedData={getselectedData} />
                        ) : ("No Data found")

                      }

                    </Paper>
                  </>
                ) : ""
              )

            })
          }

        </TabContext>
      ) :
        <div className='mt-1'>
          <button className='btn btnAddNew' onClick={() => { setopenSection(true) }}>+ Add new</button>
        </div>}


      {
        openAddSection ? (
          <AddSubFilterDialog open={openAddSection}
            dialogType={'Add Sub Section'}
            loadSubFilters={loadSubFilters} onHandleAddItem={handleAddItem} onHandleSelectedData={handleAddSectionDialogData} lastRank={lastRank} />
        ) : ""
      }
      {
        openSection ? (
          <AddSectionDialog open={openSection}
            dialogType={'Add Section'} from={'sub section'} onHandleAddItem={handleSectionOpen} onHandleSelectedData={handleAddSectionDialogData} lastRank={lastRank} />
        ) : ""
      }
      {
        openEditSection ? (
          <EditSubFilter open={openEditSection}
           loadSubFilters={loadSubFilters}
            dialogType={'Add Sub Section'} onHandleAddItem={handleEditItem} selectedDataForEdit={selectedDataForEdit} />
        ) : ""
      }
      {
        sectionItemsToggle ? (
          <SectionItemsDialog open={sectionItemsToggle} dialogType={sectionItemsdialogType} onHandleAddItem={onHandlesectionItems} sectionName={sectionNameItemsdialogType} type={2} />
        ) : ("")
      }

    </div>
  );
}

export default AddSubSection; 